export function applyFamiliarPricePoint(amount: number, currency = ''): number {
    if (!Number.isFinite(amount) || amount <= 1) return 1;

    const wholeAmount = Math.round(amount);

    if (wholeAmount < 10) {
        const pricePoints = [1, 3, 5, 7, 9];
        if (currency.trim().toUpperCase() === 'USD') {
            return [...pricePoints].reverse().find((pricePoint) => pricePoint < wholeAmount) ?? 1;
        }

        return pricePoints.reduce((closest, pricePoint) =>
            Math.abs(pricePoint - wholeAmount) < Math.abs(closest - wholeAmount) ? pricePoint : closest,
        );
    }

    if (wholeAmount < 100) {
        if (wholeAmount % 10 === 9) return wholeAmount;
        return Math.max(9, Math.round((wholeAmount + 1) / 10) * 10 - 1);
    }

    if (wholeAmount < 1000) {
        if (wholeAmount % 50 === 49) return wholeAmount;
        return Math.max(99, Math.round((wholeAmount + 1) / 50) * 50 - 1);
    }

    if (wholeAmount % 100 === 99) return wholeAmount;
    return Math.max(999, Math.round((wholeAmount + 1) / 100) * 100 - 1);
}
